export default {"src":"/_next/static/media/training-preview.37d908d3.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};